<ng-template #loaderTemplate>
    <ui-progress-bar [isIndeterminate]="true"
                     class="pos-absolute"></ui-progress-bar>
</ng-template>

<ng-template #errorTemplate>
    <span class="flex result-text"
          [uiLocalize]="'errorContent'"></span>
    <ol>
        <li class="flex layout-fill"
            [uiLocalize]="'errorCause0'"></li>
        <li class="flex layout-fill"
            [uiLocalize]="'errorCause1'"></li>
        <li class="flex layout-fill"
            [uiLocalize]="'errorCause2'"></li>
    </ol>
</ng-template>

<div class="flex layout layout-fill p-20">
    <div *ngIf="!this.isLoading; else loaderTemplate"
         class="flex layout-fill">
        <h1 [uiLocalize]="'header'"></h1>
        <div *ngIf="this.isSuccessful; else errorTemplate"
             class="layout-fill">
            <p class="layout-fill layout-row">
                <span class="flex result-text"
                      [uiLocalize]="'success'"></span>
            </p>
        </div>
    </div>
</div>
